export enum ALERT_STATUS {
	SUCCESS = "success",
	WARN = "warn",
	ERROR = "error",
	INFO = "info"
}
